/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: message-webapp-front
 * Version: 7.3.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Masque le message et persiste la fermeture.
 */
async function closeMessage() {
    const message = this.closest('div .message');
    const uuid = message.dataset.uuid;
    await fetch(`/message/close?uuid=${uuid}`);
    this.closest('div .message').style.display = 'none';
}

const messageContainer = document.querySelector('.messages-container');

if (messageContainer) {
    const messageCloseButtons = messageContainer.querySelectorAll('.message__close > button');
    messageCloseButtons.forEach(messageCloseButton => {
        messageCloseButton.addEventListener('click', closeMessage);
    });
}